export class Currency {
	id: number;
	name: string;
	isoCode: string;
}
